const config={
    baseUrl:'http://localhost:3000'
}
if (process.env.NODE_ENV === 'production') {
    config.baseUrl="https://s-contraloria.hidalgo.gob.mx"
  }

export default config